import { useEffect, useRef, useState } from 'react'

import { EMPTY_LIST } from '../../../../../../../constants/common'
import { useUserData } from '../../../../../../../hooks'
import {
  APPLICANT_PAYLOAD_FIELD,
  getMockListingApplicants,
} from '../../../../../../RentalPortalApplicant'
import { setMockListingApplicantsSeen } from '../../../../../../RentalPortalListing'
import { getHasApplicantsPayloadField } from '../../../../../RentalPortalApplicants'
import { LISTING_APPLICANTS_PAGE_SIZE } from '../../RentalPortalListingProfileApplicants.constants'

export function useListingProfileApplicants({ listingId }) {
  const currentUser = useUserData()

  const [page, setPage] = useState(1)
  const [reloadKey, setReloadKey] = useState(0)

  const [response, setResponse] = useState(null)
  const [hasError, setError] = useState(false)

  const [isInitiated, setInitiated] = useState(false)
  const [isLoading, setLoading] = useState(true)

  const readIdRef = useRef(0)

  function loadApplicants() {
    readIdRef.current += 1

    const readId = readIdRef.current

    setLoading(true)

    getMockListingApplicants({
      currentUser,
      listing_id: listingId,
      page,
      page_size: LISTING_APPLICANTS_PAGE_SIZE,
    })
      .then(({ data }) => {
        if (readIdRef.current === readId) {
          setResponse(data)
          setError(false)
          setPage(data.pagination.page)

          setMockListingApplicantsSeen(listingId)
        }
      })
      .catch(() => {
        if (readIdRef.current === readId) {
          setError(true)
        }
      })
      .finally(() => {
        if (readIdRef.current === readId) {
          setLoading(false)
          setInitiated(true)
        }
      })
  }

  useEffect(() => {
    if (listingId) {
      // eslint-disable-next-line react-hooks/set-state-in-effect -- the in-flight flag flips when the read starts
      loadApplicants()
    }
  }, [listingId, page, reloadKey])

  function handleSetPagination(nextPagination) {
    setPage(nextPagination.page)
  }

  async function handleRefresh() {
    setInitiated(false)
    setError(false)
    setReloadKey(prevReloadKey => prevReloadKey + 1)
  }

  const items = response?.results?.objects ?? EMPTY_LIST

  return {
    allItems: response?.allItems ?? EMPTY_LIST,
    handleRefresh,
    handleSetPagination,
    hasError,
    hasStage: getHasApplicantsPayloadField({
      field: APPLICANT_PAYLOAD_FIELD.stage,
      items,
    }),
    isInitiated,
    isLoading,
    items,
    pagination: {
      count: response?.pagination?.total ?? 0,
      page,
      pageCount: response?.pagination?.page_count ?? 0,
      pageSize: LISTING_APPLICANTS_PAGE_SIZE,
    },
  }
}
